import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { passConfig } from 'kts-platform-frame/utils';
import { passwordRule } from 'src/api';
import { history } from 'kts-platform-frame/routes';

class ModulesAction extends ActionBasic<ModulesState> {
  public passConfigGetByEmail = async (email) => {
    const res = await passwordRule.passConfigGetByEmail(this, { email });
    if (!res.er) {
        let str = '';
        this.modulesState.passConfig = res.res;
        const passConfigArr = passConfig(res.res, '');
        this.changePassConfigArr(passConfigArr);
        passConfigArr.forEach(ele => {
            str += ele['message'] + ',';
        });
        str = str.slice(0, str.length - 1);
        this.modulesState.newPasTipMessage = str;
        this.setModulesState();
    }
  }

  public changeNewPasTipView = (b) => {
    this.modulesState.newPasTipView = b;
    this.setModulesState();
  }

  public changePassConfigArr = (option) => {
    this.modulesState.passConfigArr = option;
    this.setModulesState();
  }

  public changePassConfigArrView = (b) => {
    this.modulesState.passConcigArrView = b;
    this.setModulesState();
  }

  public changeNewPasTipMessage = (str) => {
    this.modulesState.newPasTipMessage = str;
    this.setModulesState();
  }

  public updatePassword = async (opt) => {
    const res = await passwordRule.changeByEmail(this, opt);
    if (!res.er) {
      history.push(`/`);
    }
  }

  public setupEmail = email => {
    this.modulesState.email = email;
    console.log(email);
    this.setModulesState();
  }

  public updateConfirmDirty = () => {
    this.modulesState.confirmDirty = true;
    this.setModulesState();
  }
} 

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/modules/Home/ModifyPas/Modules.Action.ts